// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2COOf","col":"styles_col__JpriG","actions":"styles_actions__27L9C","conflict":"styles_conflict__ntJ8i"};